import { Grid } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { MelkMalekModel } from "../../Api/Models/MelkMalek";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDBox from "../../Components/MDBox";
import MDButton from "../../Components/MDButton";
import MDDivider from "../../Components/MDDivider";
import MDInput from "../../Components/MDInput";
import MDTypography from "../../Components/MDTypography";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import * as Yup from "yup";
import { ErrorToaast, InfoToaast, SuccessToaast } from "../../utils/toast/Toast";
import { v4 as uuid } from "uuid";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteDialog from "./components/DeleteDialog";

const validationSchema = Yup.object().shape({
  ShomParvande: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  MalekName: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  FamilyName: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  FatherName: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  CodeMeli: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  ShShenasname: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  CodePosti: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  Address: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  ShMobile: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  Mantaghe: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  Hoze: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  Blook: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  CodeMelk: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  MelkKind: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  MelkStatus: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  MasZamin: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  MazBana: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  ShPelak: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  TotalFloor: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  MaabarMetraj: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
  Description: Yup.string().typeError("نام بانک الزامی است").required("نام بانک الزامی است "),
});
export default function MelkMalek() {
  const melkMalek = new MelkMalekModel();
  const [searched, setSearched] = useState<any>([]);
  const [editable, setEditable] = useState<number>(0);
  const [deleteOpen, setDeleteOpen] = useState<{ open: boolean; id: number }>({ open: false, id: 0 });
  const [counter, setCounter] = useState(0);
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      ShomParvande: "",
      MalekName: "",
      FamilyName: "",
      FatherName: "",
      CodeMeli: "",
      ShShenasname: "",
      CodePosti: "",
      Address: "",
      ShMobile: "",
      Mantaghe: "",
      Hoze: "",
      Blook: "",
      CodeMelk: "",
      MelkKind: "",
      MelkStatus: "",
      MasZamin: "",
      MazBana: "",
      ShPelak: "",
      TotalFloor: "",
      MaabarMetraj: "",
      Description: "",
      isActive: false,
    },
    validationSchema,
    validateOnChange: false,
    validateOnBlur: false,
    validateOnMount: false,
    onSubmit: (items) => {
      if (editable !== 0) {
        if (!items.isActive) {
          ErrorToaast("وضعیت غیر فعال میباشد");
          return;
        }
        melkMalek
          .EditData({ ...formik.values, id: editable })
          .then((r) => SuccessToaast("با موفقیت ویرایش شد"))
          .then((e) => {
            // ErrorToaast("خطا در برقراری ارتباط");
          });
      } else {
        melkMalek
          .SubmitData(items)
          .then((r) => SuccessToaast("با موفقیت اضافه شد"))
          .then((e) => ErrorToaast("خطا در برقراری ارتباط"));
      }
      formik.resetForm();
      setEditable(0);
    },
  });
  const handleSearch = () => {
    melkMalek
      .GetSearch(
        formik.values.ShomParvande,
        formik.values.MalekName,
        formik.values.FamilyName,
        formik.values.FatherName,
        formik.values.CodeMeli,
        formik.values.ShShenasname,
        formik.values.CodePosti,
        formik.values.ShMobile,
        formik.values.Mantaghe,
        formik.values.Hoze,
        formik.values.Blook,
        formik.values.CodeMelk
      )
      .then((r) => {
        setSearched(r.data.data);
      })
      .catch((e) => ErrorToaast("مشکل در برقراری ارتباط"));
  };
  const handleRowClick = (data: any) => {
    formik.setFieldValue("ShomParvande", data.shomParvande);
    formik.setFieldValue("MalekName", data.malekName);
    formik.setFieldValue("FamilyName", data.familyName);
    formik.setFieldValue("FatherName", data.fatherName);
    formik.setFieldValue("CodeMeli", data.codeMeli);
    formik.setFieldValue("ShShenasname", data.shShenasname);
    formik.setFieldValue("CodePosti", data.codePosti);
    formik.setFieldValue("Address", data.address);
    formik.setFieldValue("ShMobile", data.shMobile);
    formik.setFieldValue("Mantaghe", data.mantaghe);
    formik.setFieldValue("Hoze", data.hoze);
    formik.setFieldValue("Blook", data.blook);
    formik.setFieldValue("CodeMelk", data.codeMelk);
    formik.setFieldValue("MelkKind", data.melkKind);
    formik.setFieldValue("MelkStatus", data.melkStatus);
    formik.setFieldValue("MasZamin", data.masZamin);
    formik.setFieldValue("MazBana", data.mazBana);
    formik.setFieldValue("ShPelak", data.shPelak);
    formik.setFieldValue("TotalFloor", data.totalFloor);
    formik.setFieldValue("MaabarMetraj", data.maabarMetraj);
    formik.setFieldValue("Description", data.description);
    formik.setFieldValue("isActive", data.isActive);
  };
  const handleChangeStatus = () => {
    if (editable === 0) return;
    //handle
    melkMalek
      .ChangeStatus(editable)
      .then((result: any) => {
        SuccessToaast("وضعیت با موفقیت تغیر یافت");
        formik.setFieldValue("isActive", !formik.values.isActive);
      })
      .catch((err: any) => {
        ErrorToaast("با مشکل مواجه شد");
      });
  };
  return (
    <DashboardLayout>
      <DashboardNavbar name={"مشخصات ملک و مالک"} />
      <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
        <MDBox bgColor="white" borderRadius="5px" p="10px 5px">
          <MDTypography fontWeight="bold" fontSize="14px">
            مشخصات مالک
          </MDTypography>
          <MDDivider />
          <MDBox py={2}>
            <Grid container gap="14px 0" textAlign={"center"}>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">شماره پرونده</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="ShomParvande"
                    value={formik.values.ShomParvande}
                    error={formik.touched.ShomParvande && Boolean(formik.errors.ShomParvande)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">نام مالک</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="MalekName"
                    value={formik.values.MalekName}
                    error={formik.touched.MalekName && Boolean(formik.errors.MalekName)}
                  />
                </Grid>
              </Grid>

              <Grid container item xs={4} alignItems="center">
                <Grid item px={2} width="150px">
                  <MDTypography fontSize="15px">نام خانوادگی</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="FamilyName"
                    value={formik.values.FamilyName}
                    error={formik.touched.FamilyName && Boolean(formik.errors.FamilyName)}
                  />
                </Grid>
              </Grid>

              <Grid container item xs={4} alignItems="center">
                <Grid item px={2} width="150px">
                  <MDTypography fontSize="15px">نام پدر</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="FatherName"
                    value={formik.values.FatherName}
                    error={formik.touched.FatherName && Boolean(formik.errors.FatherName)}
                  />
                </Grid>
              </Grid>

              <Grid container item xs={4} alignItems="center">
                <Grid item px={2} width="150px">
                  <MDTypography fontSize="15px">کد ملی</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="CodeMeli"
                    value={formik.values.CodeMeli}
                    error={formik.touched.CodeMeli && Boolean(formik.errors.CodeMeli)}
                  />
                </Grid>
              </Grid>

              <Grid container item xs={4} alignItems="center">
                <Grid item px={2} width="150px">
                  <MDTypography fontSize="15px">شماره شناسنامه</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="ShShenasname"
                    value={formik.values.ShShenasname}
                    error={formik.touched.ShShenasname && Boolean(formik.errors.ShShenasname)}
                  />
                </Grid>
              </Grid>

              <Grid container item xs={4} alignItems="center">
                <Grid item px={2} width="150px">
                  <MDTypography fontSize="15px">کد پستی</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="CodePosti"
                    value={formik.values.CodePosti}
                    error={formik.touched.CodePosti && Boolean(formik.errors.CodePosti)}
                  />
                </Grid>
              </Grid>

              <Grid container item xs={4} alignItems="center">
                <Grid item px={2} width="150px">
                  <MDTypography fontSize="15px">آدرس</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="Address"
                    value={formik.values.Address}
                    error={formik.touched.Address && Boolean(formik.errors.Address)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={4} alignItems="center">
                <Grid item px={2} width="150px">
                  <MDTypography fontSize="15px">موبایل</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="ShMobile"
                    value={formik.values.ShMobile}
                    error={formik.touched.ShMobile && Boolean(formik.errors.ShMobile)}
                  />
                </Grid>
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
        <MDBox bgColor="white" borderRadius="5px" p="10px 5px">
          <MDTypography fontWeight="bold" fontSize="14px">
            مشخصات ملک
          </MDTypography>
          <MDDivider />
          <MDBox py={2}>
            <Grid container gap="14px 0" textAlign={"center"}>
              <Grid container item xs={3} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">منطقه</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="Mantaghe"
                    value={formik.values.Mantaghe}
                    error={formik.touched.Mantaghe && Boolean(formik.errors.Mantaghe)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={3} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">حوزه</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="Hoze"
                    value={formik.values.Hoze}
                    error={formik.touched.Hoze && Boolean(formik.errors.Hoze)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={3} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">بلوک</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="Blook"
                    value={formik.values.Blook}
                    error={formik.touched.Blook && Boolean(formik.errors.Blook)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={3} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">کد ملک</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="CodeMelk"
                    value={formik.values.CodeMelk}
                    error={formik.touched.CodeMelk && Boolean(formik.errors.CodeMelk)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={3} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">نوع ملک</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="MelkKind"
                    value={formik.values.MelkKind}
                    error={formik.touched.MelkKind && Boolean(formik.errors.MelkKind)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={3} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">وضعیت ملک</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="MelkStatus"
                    value={formik.values.MelkStatus}
                    error={formik.touched.MelkStatus && Boolean(formik.errors.MelkStatus)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={3} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">مساحت زمین</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="MasZamin"
                    value={formik.values.MasZamin}
                    error={formik.touched.MasZamin && Boolean(formik.errors.MasZamin)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={3} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">مساحت بنا</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="MazBana"
                    value={formik.values.MazBana}
                    error={formik.touched.MazBana && Boolean(formik.errors.MazBana)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={3} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">شماره پلاک ثبتی</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="ShPelak"
                    value={formik.values.ShPelak}
                    error={formik.touched.ShPelak && Boolean(formik.errors.ShPelak)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={3} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">تعداد طبقات</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="TotalFloor"
                    value={formik.values.TotalFloor}
                    error={formik.touched.TotalFloor && Boolean(formik.errors.TotalFloor)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={3} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">متراژ معبر</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="MaabarMetraj"
                    value={formik.values.MaabarMetraj}
                    error={formik.touched.MaabarMetraj && Boolean(formik.errors.MaabarMetraj)}
                  />
                </Grid>
              </Grid>
              <Grid container item xs={6} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">وضعیت</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  {/* <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="Vaziat"
                    value={formik.values.Vaziat}
                    error={formik.touched.Vaziat && Boolean(formik.errors.Vaziat)}
                  /> */}
                  {formik.values.isActive ? (
                    <MDButton fullWidth onClick={handleChangeStatus} variant="outlined" color="success">
                      فعال
                    </MDButton>
                  ) : (
                    <MDButton fullWidth onClick={handleChangeStatus} variant="outlined" color="error">
                      غیر فعال
                    </MDButton>
                  )}
                </Grid>
              </Grid>
              <Grid container item xs={6} alignItems="center">
                <Grid item width="150px">
                  <MDTypography fontSize="15px">توضیحات</MDTypography>
                </Grid>
                <Grid item flex={1}>
                  <MDInput
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    name="Description"
                    value={formik.values.Description}
                    error={formik.touched.Description && Boolean(formik.errors.Description)}
                  />
                </Grid>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox>
            <Grid container columnGap={4} columns={10} justifyContent="center">
              <Grid item xs={2}>
                <MDButton
                  fullWidth
                  variant="contained"
                  onClick={() => {
                    formik.resetForm();
                    setEditable(0);
                  }}
                  color="success"
                >
                  جدید
                </MDButton>
              </Grid>
              <Grid item xs={2}>
                <MDButton fullWidth variant="contained" color="warning" type="submit">
                  ثبت
                </MDButton>
              </Grid>

              <Grid item xs={2}>
                <MDButton fullWidth variant="contained" color="primary" onClick={handleSearch}>
                  جستجو
                </MDButton>
              </Grid>
              <Grid item xs={2}>
                <MDButton
                  fullWidth
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    if (editable && editable !== 0) {
                      if (!formik.values.isActive) {
                        ErrorToaast("وضعیت غیر فعال میباشد");
                        return;
                      }
                      navigate(`/avareznosazi/${editable}`, { replace: true });
                    } else {
                      InfoToaast("یک ردیف را انتخاب کنید");
                    }
                  }}
                >
                  عوارض
                </MDButton>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox minHeight="40vh" maxHeight="40vh" sx={{ overflow: "auto" }} bgColor="#adaabb" mt={4} border="2px #5b5b5b solid">
            <MDBox bgColor="#eeeeee" px={1}>
              <Grid container textAlign="center">
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>شماره پرونده</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>نام مالک</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>نام خانوادگی</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>نام پدر</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>کد ملی</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>شماره شناسنامه</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>کد پستی</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>شماره موبایل</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>منطقه</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>حوزه</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>بلوک</MDTypography>
                </Grid>
                <Grid item xs={1}>
                  <MDTypography fontSize={"14px"}>حذف</MDTypography>
                </Grid>
              </Grid>
            </MDBox>
            {searched.length > 0 &&
              searched.map((data: any, index: number) => {
                return (
                  <MDBox
                    bgColor={index % 2 === 0 ? "#fbfbfb" : "white"}
                    px={1}
                    key={uuid()}
                    onClick={() => {
                      handleRowClick(data);
                      setEditable(data.id);
                    }}
                    sx={{ ":hover": { background: "#9185c8" }, cursor: "pointer" }}
                  >
                    <Grid container textAlign="center">
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{data.shomParvande ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{data.malekName ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{data.familyName ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{data.fatherName ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{data.codeMeli ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{data.shShenasname ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{data.codePosti ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{data.shMobile ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{data.mantaghe ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{data.hoze ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDTypography fontSize={"14px"}>{data.blook ?? ""}</MDTypography>
                      </Grid>
                      <Grid item xs={1}>
                        <MDBox
                          onClick={(e: any) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setDeleteOpen({ open: true, id: data.id });
                          }}
                        >
                          <DeleteIcon color="error" />
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                );
              })}
          </MDBox>
        </MDBox>
        <DeleteDialog
          open={deleteOpen.open}
          id={deleteOpen.id}
          setClose={() => setDeleteOpen({ id: 0, open: false })}
          onDone={() => {
            setDeleteOpen({ open: false, id: 0 });

            handleSearch();
          }}
        />
      </MDBox>
    </DashboardLayout>
  );
}
